import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { animated } from '@react-spring/web';
import classNames from 'classnames';
import find from "lodash/find";
import isNil from "lodash/isNil";
import { getFormattedTime } from '../../search-module/components/date-time/mobile/helpers/helpers';
import { TimeData } from '../../search-module/components/date-time/mobile/data/time-data';

export const MainTray = injectIntl((props) => {
  const {
    transitionStyles,
    dateTimeDisplay,
    setActiveTray,
    timeValue,
    dateValue,
    onReset,
    intl,
    clearable
  } = props;

  const dateDisplay = useMemo(() => {
    if (!dateValue) {
      return intl.formatMessage({ id: 'shared-components.main-tray-datetime-picker.any', defaultMessage: 'Any' });
    }
    return intl.formatDate(dateValue, {
      month: 'short',
      day: 'numeric'
    });
  }, [dateValue]);

  const startTimeDisplay = useMemo(() => {
    if (!timeValue || isNil(timeValue.startTime)) {
      return intl.formatMessage({ id: 'shared-components.main-tray-datetime-picker.any', defaultMessage: 'Any' });
    }
    return getFormattedTime(find(TimeData, (time) => time.time_index === timeValue.startTime), intl);
  }, [timeValue]);

  const endTimeDisplay = useMemo(() => {
    if (!timeValue || isNil(timeValue.endTime)) {
      return intl.formatMessage({ id: 'shared-components.main-tray-datetime-picker.any', defaultMessage: 'Any' });
    }
    return getFormattedTime(find(TimeData, (time) => time.time_index === timeValue.endTime), intl);
  }, [timeValue]);

  return (
    <animated.div style={transitionStyles} className="full-width">
      <div className="sub-tray-header main responsive-padding relative flex column center">
        <label className='text-gray-900 h4'>
          <FormattedMessage
            id='shared-components.main-tray-datetime-picker.label'
            defaultMessage='When?'
          />
        </label>
        <span className="datetime-display text-gray-900">
          {dateTimeDisplay}
        </span>
      </div>
      <button
        className="main-tray-btn flex middle space-between responsive-padding btn-clear text-gray-900"
        onClick={(e) => {
          e.preventDefault();
          setActiveTray('date');
        }}
      >
        <span className='h6'>
          <FormattedMessage
            id='shared-components.main-tray-datetime-picker.date'
            defaultMessage='Date'
          />
        </span>
        <span className='flex middle'>
          <span
            className={!dateDisplay ? 'text-gray-500' : 'text-gray-600'}
            style={{ fontSize: '18px' }}
          >
            {dateDisplay}
          </span>
          <i
            className={classNames(
              'icon-image-arrows text-gray-600',
              !dateValue ? 'text-gray-500' : 'text-gray-600'
            )}
            style={{ transform: 'rotate(180deg)' }}
          />
        </span>
      </button>
      <button
        className={classNames(
          'main-tray-btn',
          'flex middle space-between',
          'responsive-padding btn-clear text-gray-900 ',
          { disabled: !dateValue }
        )}
        onClick={(e) => {
          e.preventDefault();
          setActiveTray('startTime');
        }}
      >
        <span className="h6">
          <FormattedMessage
            id='shared-components.main-tray-datetime-picker.start-time'
            defaultMessage='Start time'
          />
        </span>
        <span className="flex middle">
          <span
            className={!dateValue ? 'text-gray-500' : 'text-gray-600'}
            style={{ fontSize: '18px' }}
          >
            {startTimeDisplay}
          </span>
          <i
            className={classNames(
              'icon-image-arrows text-gray-600',
              !dateValue ? 'text-gray-500' : 'text-gray-600'
            )}
            style={{ transform: 'rotate(180deg)' }}
          />
        </span>
      </button>
      <button
        className={classNames(
          'main-tray-btn',
          'flex middle space-between',
          'responsive-padding btn-clear text-gray-900',
          { disabled: !dateValue || isNil(timeValue.startTime) }
        )}
        onClick={(e) => {
          e.preventDefault();
          setActiveTray('endTime');
        }}
      >
        <span className='h6'>
          <FormattedMessage
            id="shared-components.main-tray-datetime-picker.end-time"
            defaultMessage="End time"
          />
        </span>
        <span className="flex middle">
          <span
            className={!dateValue || isNil(timeValue.startTime) ? 'text-gray-500' : 'text-gray-600'}
            style={{ fontSize: '18px' }}
          >
            {endTimeDisplay}
          </span>
          <i
            className={classNames(
              'icon-image-arrows text-gray-600',
              !dateValue || isNil(timeValue.startTime) ? 'text-gray-500' : 'text-gray-600'
            )}
            style={{ transform: 'rotate(180deg)' }}
          />
        </span>
      </button>
      {
        clearable ? <div className="responsive-padding sub-tray-reset-wrapper">
          <button className="btn-clear h6 heavy" onClick={onReset}>
            <FormattedMessage
              id="shared-components.main-tray-datetime-picker.clear"
              defaultMessage="Clear"
            />
          </button>
        </div> : null
      }

    </animated.div>
  );
});

MainTray.propTypes = {
  transitionStyles: PropTypes.object,
  dateTimeDisplay: PropTypes.string,
  setActiveTray: PropTypes.func,
  timeValue: PropTypes.object,
  dateValue: PropTypes.object,
  onReset: PropTypes.func,
  intl: intlShape
};
